import { Injectable } from '@angular/core';

import { AuthenticationSandbox, HostNameGuard } from '@mediahaven/shared';
import { EnvironmentConfigService, SettingsService } from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export class MediahavenHostNameGuard extends HostNameGuard {
    protected app = 'mh';

    constructor(
        protected configService: EnvironmentConfigService,
        protected settingsService: SettingsService,
        protected authSandBox: AuthenticationSandbox
    ) {
        super(configService, settingsService, authSandBox);
    }
}
